import type { MTTDataType, MTTSubcriptionDataType } from '../../types/MTT';

export const getMTTDataTypeKey = (dataType: string): MTTDataType =>
  dataType === 'mock' ? 'mock' : 'tournaments';

export const getMTTSubscriptionDataKey = (dataType: string): MTTSubcriptionDataType =>
  dataType === 'mock' ? 'crudm' : 'crud';

export const getUSNumberFormat = (num: number) => new Intl.NumberFormat('en-US').format(num);
